import Store from "../../../../Store/Store";

class UnitPaidStatusTypeContainer {
  public pickIdFromLabel(label) {
    const UnitPaidStatusTypes = Store.getConfigurator().getState().globalTypes?.UnitPaidStatus

    for (const type in UnitPaidStatusTypes) {
      if (UnitPaidStatusTypes[type].label.toLowerCase() === label.toLowerCase()) {
        return UnitPaidStatusTypes[type].id
      }
    }
  }

  public pickLabelFromId(id) {
    const UnitPaidStatusTypes = Store.getConfigurator().getState().globalTypes?.UnitPaidStatus

    for (const type in UnitPaidStatusTypes) {
      if (UnitPaidStatusTypes[type].id === id) {
        return UnitPaidStatusTypes[type].label
      }
    }
  }
}

export default new UnitPaidStatusTypeContainer();
